import { render, staticRenderFns } from "./Goods.vue?vue&type=template&id=08bb7125&scoped=true"
import script from "./Goods.vue?vue&type=script&lang=ts"
export * from "./Goods.vue?vue&type=script&lang=ts"
import style0 from "./Goods.scss?vue&type=style&index=0&id=08bb7125&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bb7125",
  null
  
)

export default component.exports